import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Chip } from "@mui/material";
import Coverage, { CoverageStatus } from "../interfaces/coverage";

const getStatusColor = (status: CoverageStatus): "warning" | "success" | "error" | "default" => {
  switch (status) {
    case CoverageStatus.PENDING_REVIEW:
      return "warning";
    case CoverageStatus.APPROVED:
      return "success";
    case CoverageStatus.REJECTED:
      return "error";
    default:
      return "default";
  }
};

const getCoverageColDef = (): GridColDef[] => {
  const columns: GridColDef[] = [
    { field: 'username', headerName: 'Username', width: 150 },
    { field: 'pin_code', headerName: 'Pin Code', width: 120 },
    { 
      field: 'area_name', 
      headerName: 'Area Name', 
      width: 180,
      valueGetter: (_value: any, row: Coverage) => row.pincode_details?.area_name || ''
    },
    { 
      field: 'state_name', 
      headerName: 'State', 
      width: 150,
      valueGetter: (_value: any, row: Coverage) => row.pincode_details?.state_name || ''
    },
    { 
      field: 'district', 
      headerName: 'District', 
      width: 150,
      valueGetter: (_value: any, row: Coverage) => row.pincode_details?.district || ''
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 150,
      renderCell: (params: GridRenderCellParams<Coverage>) => (
        <Chip 
          label={params.row.status} 
          color={getStatusColor(params.row.status)}
          size="small"
        />
      )
    },
    { field: 'created_date', headerName: 'Created Date', width: 180 },
    { field: 'updated_date', headerName: 'Updated Date', width: 180 }
  ];

  return columns;
};

export default getCoverageColDef;
